var scope_0 = require('/opt/build/repo/site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/79c83d1bd79a22aa998025c74b990ef1.js').default;

var scope_1 = require('/opt/build/repo/site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;

export default Object.assign({}, scope_0, scope_1);